export default __webpack_public_path__ + "static/media/img2.03a73c9d.jpg";